// Per-route SEO metadata (bilingual). Keep titles < ~60 chars, descriptions < ~155.
const BRAND = "Autobus Limo Mont Royal";
const OG = "https://images.unsplash.com/photo-1771775751121-3091d79073d4?fm=jpg&q=80&w=1200";

export const PAGE_SEO = {
  home: {
    path: "/", image: OG,
    en: { title: `Montréal Limousine, Chauffeur & Bus Service | ${BRAND}`,
          description: "Private chauffeur, limousine, Ford Sprinter and charter bus in Montréal — airport transfers, corporate travel, weddings and group transportation. Licensed, insured, 24/7." },
    fr: { title: `Limousine, chauffeur privé et autobus à Montréal | ${BRAND}`,
          description: "Chauffeur privé, limousine, Ford Sprinter et autobus nolisé à Montréal — transferts aéroport, corporatif, mariages et groupes. Licencié, assuré, 24/7." },
  },
  book: {
    path: "/book", image: OG,
    en: { title: `Book a Ride Online | ${BRAND}`,
          description: "Reserve a chauffeur, limousine, Ford Sprinter or charter bus in Montréal in minutes. Instant pricing, secure deposit and real-time vehicle availability." },
    fr: { title: `Réserver en ligne | ${BRAND}`,
          description: "Réservez un chauffeur, une limousine, un Ford Sprinter ou un autobus nolisé à Montréal en quelques minutes. Prix instantané, dépôt sécurisé et disponibilité en temps réel." },
  },
  airport: {
    path: "/airport-transfers", image: OG,
    en: { title: `Montréal Airport Transfers (YUL) | ${BRAND}`,
          description: "Reliable YUL Montréal-Trudeau airport transfers with flight tracking, meet-and-greet and fixed pricing. Private chauffeur and group vehicles available 24/7." },
    fr: { title: `Transferts aéroport Montréal (YUL) | ${BRAND}`,
          description: "Transferts fiables vers l'aéroport Montréal-Trudeau (YUL) avec suivi des vols, accueil personnalisé et prix fixe. Chauffeur privé et véhicules de groupe, 24/7." },
  },
  corporate: {
    path: "/corporate", image: OG,
    en: { title: `Corporate Transportation & Accounts | ${BRAND}`,
          description: "Corporate ground transportation in Montréal — executive chauffeurs, roadshows, event shuttles and managed billing accounts with priority dispatch." },
    fr: { title: `Transport corporatif et comptes | ${BRAND}`,
          description: "Transport corporatif à Montréal — chauffeurs exécutifs, roadshows, navettes d'événements et comptes de facturation gérés avec répartition prioritaire." },
  },
  weddings: {
    path: "/weddings-events", image: OG,
    en: { title: `Wedding & Event Limousines | ${BRAND}`,
          description: "Elegant wedding and event transportation in Montréal — limousines, Ford Sprinter vans and charter buses with coordinated timing for your special day." },
    fr: { title: `Limousines pour mariages et événements | ${BRAND}`,
          description: "Transport élégant pour mariages et événements à Montréal — limousines, fourgonnettes Ford Sprinter et autobus nolisés avec horaires coordonnés." },
  },
  groups: {
    path: "/group-transportation", image: OG,
    en: { title: `Group Transportation & Charter Bus | ${BRAND}`,
          description: "Group transportation in Montréal for 10–56 passengers — minibuses and charter buses for tours, corporate outings, sports teams and celebrations." },
    fr: { title: `Transport de groupe et autobus nolisé | ${BRAND}`,
          description: "Transport de groupe à Montréal pour 10 à 56 passagers — minibus et autobus nolisés pour tours, sorties corporatives, équipes sportives et célébrations." },
  },
  serviceAreas: {
    path: "/service-areas", image: OG,
    en: { title: `Service Areas — Montréal & Beyond | ${BRAND}`,
          description: "We serve Montréal, Laval, Longueuil, the South Shore, plus intercity trips to Québec City, Ottawa and Toronto with professional chauffeurs." },
    fr: { title: `Zones desservies — Montréal et plus | ${BRAND}`,
          description: "Nous desservons Montréal, Laval, Longueuil, la Rive-Sud, ainsi que les trajets vers Québec, Ottawa et Toronto avec chauffeurs professionnels." },
  },
};
